import { 
  COMP_SWATCH_COLOR_PARENT_SELECT_BEHAVIOUR,
  COMP_DOM,
  COMP_NO_SELECTION,
  COMP_GROUP_BTN_AUTO_SELECT,
  COMP_LOAD_STATE_NAV,
  GALLERY_COLOR_PARENT,
  COMP_UPLOAD_UI,
  COMP_IMAGE_EDITOR,
  COMP_UPLOAD_PRICING_BEHAVIOUR,
  COMP_MATCH_SELECTION,
  COMP_ADD_LATER,
  COMP_WARNINGS
} from "../constants";
import { DomApi, ComponentManager } from "../utils";
import { NoSelectionComponent } from "../components/no_selection";
import { GroupBtnAutoSelectComponent } from "../components/group_btn_auto_select";
import { LoadStateGroupNav } from "../components/load_state_group_nav";
import { SwatchColorParentSelectBehaviour } from "../components/swatch_color_parent_select_behavior";
import { UploadComponent } from "../components/upload";
import { AddLaterBehaviorComponent } from "../components/add_later";
import { MatchSelectionsBehavior } from "../components/match_selections";
import { WarningsComponent } from "../components/warnings";

export class SwatchGallery {
  constructor($container, controller) {
    this.$container = $container;
    this.controller = controller;
    this.id = $container.attr('id');
    this.side = $container.attr('data-side');
    this.layer = $container.attr('data-layer');
    this.components = new ComponentManager();

    this.components.add(COMP_SWATCH_COLOR_PARENT_SELECT_BEHAVIOUR, new SwatchColorParentSelectBehaviour(this));
    this.components.add(COMP_DOM, new DomApi(this, this.$container));
    this.components.add(COMP_NO_SELECTION, new NoSelectionComponent(this));
    this.components.add(COMP_GROUP_BTN_AUTO_SELECT, new GroupBtnAutoSelectComponent(this));
    this.components.add(COMP_LOAD_STATE_NAV, new LoadStateGroupNav(this));
    this.components.add(COMP_MATCH_SELECTION, new MatchSelectionsBehavior(this.controller, this.controller.$container, this));
    this.components.add(COMP_WARNINGS, new WarningsComponent(this));

    this.dom = this.components.get(COMP_DOM);

    if ($container.attr('data-type') == GALLERY_COLOR_PARENT) {

      if (!controller.selected_iem.designer_options.disable_upload) {
        this.hasUploadComponent = true;
        this.components.add(COMP_UPLOAD_UI, new UploadComponent(this));
        this.components.add(COMP_ADD_LATER, new AddLaterBehaviorComponent(this));
        this.components.add(COMP_IMAGE_EDITOR, this.controller.imageEditorComponent);
        this.components.add(COMP_UPLOAD_PRICING_BEHAVIOUR, this.controller.uploadPricingComponent);
      }
    }
  }

  async init() {

    const me = this;

    if (this.$container.find('.swatch-group-btn.active').length == 0) {
      me.activateSwatchGroup(this.$container.find('.swatch-group-btn:first'));
    }

    this.$container.find('.swatch-group-btn').click(function () {
      me.activateSwatchGroup($(this));
    });

    this.$container.find('.swatch').click(function () {
      me.activateSwatch($(this));
    });

    await this.components.init(this);
  }

  async activateSwatchGroup($swatchGroup, updateState) {
    const name = $swatchGroup.attr('data-name');
    const $targetSwatchesContainer = this.$container.find(`.swatch-group[data-name=${name}]`);
    this.$container.find('.swatch-group').not($targetSwatchesContainer).removeClass('active');
    this.$container.find('.swatch-group-btn').not($swatchGroup).removeClass('active');
    $targetSwatchesContainer.addClass('active');
    $swatchGroup.addClass('active');
    this.$container.scrollTop();

    this.components.broadcast('activateSwatchGroup', $swatchGroup);
  }

  async activateSwatch($swatch, matLayers, updateState) {
    if ($swatch.hasClass("blacklisted")) {
      return;
    }

    try {
      this.controller.startWait();
      let forceNext = false;
      let $forceNext = undefined;
      const $currentSwatch = this.$container.find('.gallery .swatch-group.active .swatch.active');
      const currentSwatchName = $currentSwatch.attr('data-name');
      const currentSwatchGroup = $currentSwatch.attr('data-group');
      const currentSwatch = this.controller.swatches[currentSwatchName] || undefined;
      const name = $swatch.attr('data-name');
      const group = $swatch.attr('data-group');
      const side = $swatch.attr('data-side');
      const swatch = this.controller.swatches[name];
      let swatchSelectEventPayload = undefined;
      let swatchColorSelectEventPayload = undefined;

      let applySwatch = swatch;
      let applyGroupName = group;

      // find swatch color if previously selected
      const $currentColors = this.$container.parent().find(`[data-parent=${this.id}]`);
      const $activeColor = $currentColors.find(`.swatch[data-parent-swatch=${currentSwatchName}].active`);
      const activeColorLabel = $activeColor.length > 0 ? $activeColor.attr('label').trim().toLowerCase() : undefined;

      // enable color swatches
      const $colors = this.$container.parent().find(`[data-parent=${this.id}][data-side=${side}]`);

      if ($colors.length > 0) {
        $colors.show();
        // Find color swatch that matches previous color selection if one is available
        let $targetColor = $colors.find(`[data-for-swatch=${swatch.name}] .swatch`).filter(function () {
          return ($(this).attr('label') || "").trim().toLowerCase() == activeColorLabel;
        });
        let targetSwatch = this.controller.swatches[$targetColor.attr('data-name')] || undefined;

        if (targetSwatch && activeColorLabel) {
          // override what color/material to apply when updating child color swatch
          applySwatch = targetSwatch;
          applyGroupName = $targetColor.attr('data-group');
          $targetColor.addClass("active");

          let $targetContainer = $targetColor.closest('.category-option');
          if ($targetContainer && (updateState == undefined || updateState == true)) {

            swatchColorSelectEventPayload = {
              id: $targetContainer.attr('id'),
              layer: this.layer,
              side: this.side,
              name: applySwatch.name,
              group: this.controller.groupsByName[applyGroupName],
              parentSwatchName: $targetColor.attr('data-parent-swatch') || undefined
            };
          }
        }
      }

      // Check swatch options to enable/dissable groups
      if (applySwatch.options) {
        const disable_selection = async (layer) => {
          await this.controller.updateMaterial({
            base_color: '#fff'
          }, this.side, layer);

          // remove selection from UI
          const $disable_cat = this.controller.$container.find(`.category-option[data-layer="${layer}"][data-side="${this.side.toLowerCase()}"]`);
          // remove has-selection styling
          $disable_cat.removeClass('has-selection');
          // remove swatch selection
          $disable_cat.find('.swatch.active').removeClass('active');
          $disable_cat.find('.title .icon').empty();
          $disable_cat.find('.title .label').empty();
          $disable_cat.find('.title .price').empty();

          this.$container.trigger('swatch-selected', {
            id: $disable_cat.attr('id'),
            layer: $disable_cat.attr('data-layer'),
            side: $disable_cat.attr('data-side'),
            name: "-clear-option-",
            group: { name: `${$disable_cat.attr('id')}-${this.side}`, group_type: $disable_cat.attr('id'), group_label: `${this.side} ${$disable_cat.attr('data-label')}` }
          });

          if ($disable_cat.attr('data-layer') == "Art") {
            const art_color_id = $disable_cat.attr('data-layer') + '-' + $disable_cat.attr('data-side') + '-colors';
            this.$container.trigger('swatch-selected', {
              id: art_color_id,
              layer: art_color_id,
              side: $disable_cat.attr('data-side'),
              name: "-clear-option-",
              group: { name: art_color_id, group_type: 'colors' }
            });
          }
        }

        if (applySwatch.options.disable_faceplates) {
          await disable_selection('Face-Plate');
        }
        if (applySwatch.options.disable_art) {
          await disable_selection('Art');
        }
      }

      await this.components.asyncBroadcast("applySwatch", applySwatch);

      if (!matLayers) {
        await this.controller.updateMaterial(applySwatch.material, this.side, this.layer);
      } else {
        matLayers.push({
          material: applySwatch.material,
          side: this.side,
          layer: this.layer
        });
      }

      if (!swatchSelectEventPayload && (updateState == undefined || updateState == true)) {
        swatchSelectEventPayload = {
          id: this.$container.attr('id'),
          layer: this.layer,
          side: this.side,
          name,
          group: this.controller.groupsByName[group],
          parentSwatchName: $swatch.attr('data-parent-swatch') || undefined
        };
      }

      // Apply parent swatch first
      if (swatchSelectEventPayload) {
        this.$container.trigger('swatch-selected', swatchSelectEventPayload);
      }
      // Apply child color second
      if (swatchColorSelectEventPayload) {
        this.$container.trigger('swatch-selected', swatchColorSelectEventPayload);
      }

      // activate swatch on UI
      this.$container.find('.swatch').not($swatch).removeClass('active');
      $swatch.addClass('active');
      this.$container.find('.title .icon').css("background-image", `url(${swatch.swatch_icon})`);

      // Update price
      this.$container.find('.label').text(`: ${swatch.swatch_label}`);
      if (Reflect.has(swatch, 'item')) {
        this.$container.find('.price').text(`+ ${swatch.item.price.formatted_price}`);
      } else {
        this.$container.find('.price').text('');
      }

      if (Reflect.has(swatch, 'colors')) {
        // Ensure the correct swatch group is displayed in the referenced child colors
        // This means correct side and swatch group name
        const $colorsGroup = this.controller.$formContainer.find(`.swatch-colors[data-side=${side}]`).find(`.swatch-group[data-for-swatch=${swatch.name}]`);
        $colorsGroup.closest('.gallery').find('.swatch-group').not($colorsGroup).hide();
        $colorsGroup.show();
      }

      this.controller.updateBlacklist();

      // move onto next category if not enabled
      this.controller._moveNextCategory(this.$container, "Swatch Gallery", forceNext, $forceNext);

      // mark this category as having selection. Used to disable auto move
      // to next category when previous one's selection changes.
      this.$container.addClass('has-selection');

      this.controller.validate();
      this.components.broadcast('activateSwatch', $swatch, matLayers, updateState);
    } finally {
      this.controller.endWait();
    }
  }

  async loadState(matLayers, state) {
    let active_choice = null;
    let isColorParent = false;

    for (let choice of Object.values(this.controller.state.choices)) {
      if (choice.categoryId == this.id) {
        isColorParent = false;
        active_choice = choice;
        break;
      } else if (choice.categoryId.search(/\-colors$/) > -1 && choice.categoryId.replace(/\-colors$/, '') == this.id) {
        isColorParent = true;
        active_choice = choice;
        break;
      }
    }

    if (active_choice) {
      if (isColorParent == false) {
        const $activeGroupBtn = this.$container
          .find(`.swatch-group-btn[data-name=${active_choice.group.name}]`);
        if ($activeGroupBtn.length > 0) {
          await this.activateSwatchGroup($activeGroupBtn);
        }

        const $activeSwatch = this.$container
          .find(`.swatch[data-group=${active_choice.group.name}][data-name=${active_choice.name}]`);
        if ($activeSwatch.length > 0) {
          await this.activateSwatch($activeSwatch, matLayers);
        }
      } else {
        const $activeGroupBtn = this.$container
          .find(`.swatch-group-btn[data-name=${active_choice.group.name}]`);
        if ($activeGroupBtn.length > 0) {
          await this.activateSwatchGroup($activeGroupBtn, false);
        }

        const $activeSwatch = this.$container
          .find(`.swatch[data-group=${active_choice.group.name}][data-name=${active_choice.parent_swatch_name}]`);
        if ($activeSwatch.length > 0) {
          await this.activateSwatch($activeSwatch, [], false);
        }
      }

      this.components.broadcast('onStateLoaded');
    }

    await this.components.asyncBroadcast('loadState', matLayers, state);
  }
}